export default __webpack_public_path__ + "img/68aed130b749880cd21600154a8e63a2.png";